import { render } from "./ProjectTemplateForm.vue?vue&type=template&id=98832b5e&scoped=true&ts=true"
import script from "./ProjectTemplateForm.vue?vue&type=script&lang=ts"
export * from "./ProjectTemplateForm.vue?vue&type=script&lang=ts"

import "./ProjectTemplateForm.vue?vue&type=style&index=0&id=98832b5e&scoped=true&lang=css"

import exportComponent from "/home/steffen/IdeaProjects/Antara/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98832b5e"]])

export default __exports__